// extracted by mini-css-extract-plugin
export default {"container":"TypeSelector_container__JeCGv","button":"TypeSelector_button__io3y2"};